export default __webpack_public_path__ + "static/slider.stadtamthall.klein-d6c957fca0ae0d94f0fa4f923859c39c.webp";